export const breakpoints = {
  base: '0rem',
  sm: '26.25rem',
  md: '40rem',
  lg: '53.75rem',
  xl: '67.5rem',
  '2xl': '81.25rem',
}
